export var Types;
(function (Types) {
    Types[Types["Undefined"] = 1] = "Undefined";
    Types[Types["Null"] = 2] = "Null";
    Types[Types["Boolean"] = 3] = "Boolean";
    Types[Types["String"] = 4] = "String";
    Types[Types["Symbol"] = 5] = "Symbol";
    Types[Types["Number"] = 6] = "Number";
    Types[Types["Object"] = 7] = "Object";
    Types[Types["Array"] = 8] = "Array";
    Types[Types["Buffer"] = 9] = "Buffer";
    Types[Types["Map"] = 10] = "Map";
    Types[Types["Set"] = 11] = "Set";
    Types[Types["ForwardValue"] = 12] = "ForwardValue";
    Types[Types["IteratorResult"] = 13] = "IteratorResult";
    Types[Types["IterableIterator"] = 14] = "IterableIterator";
    Types[Types["Error"] = 15] = "Error";
    Types[Types["ArrayStorage"] = 16] = "ArrayStorage";
    Types[Types["MapStorage"] = 17] = "MapStorage";
    Types[Types["SetStorage"] = 18] = "SetStorage";
    Types[Types["Transaction"] = 19] = "Transaction";
    Types[Types["Output"] = 20] = "Output";
    Types[Types["Attribute"] = 21] = "Attribute";
    Types[Types["Input"] = 22] = "Input";
    Types[Types["Account"] = 23] = "Account";
    Types[Types["Asset"] = 24] = "Asset";
    Types[Types["Contract"] = 25] = "Contract";
    Types[Types["Header"] = 26] = "Header";
    Types[Types["Block"] = 27] = "Block";
    Types[Types["Iterable"] = 28] = "Iterable";
})(Types || (Types = {}));

//# sourceMappingURL=Types.js.map
